import React from 'react';
import PropTypes from 'prop-types';

import { Section } from '../Section';

import {
	Wrapper,
	HeaderRow,
	ListRow,
	HeaderItemToggle,
	HeaderItemName,
	HeaderItemOptions,
	VerticalDivider,
	IndexText,
	OptionsText,
	TextInput,
	ToggleSwitch,
	ListToggleWrapper,
	ListNameWrapper,
	ListOptionsWrapper,
} from './styles';

export const CustomFiltersSection = ({
	customFilters,
	animationIndex,
	onChange,
}) => {
	return (
		<Section
			title="Custom Filters"
			description="Data added to the custom data columns is displayed below.  Use the settings to control which ones are available in the chart pages as filters and comparison dimensions"
			animationIndex={animationIndex}
		>
			<Wrapper>
				<HeaderRow>
					<HeaderItemToggle>On/off</HeaderItemToggle>
					<HeaderItemName>Filter Name</HeaderItemName>
					<HeaderItemOptions>Options preview</HeaderItemOptions>
				</HeaderRow>

				{customFilters
					.sort((a, b) => {
						const numA = parseInt(a.name.match(/\d+/)[0], 10); // Extract number from 'customfilter1'
						const numB = parseInt(b.name.match(/\d+/)[0], 10); // Extract number from 'customfilter2'
						return numA - numB; // Ascending order
					})
					.map((filter, idx) => (
						<>
							<CustomFilterItem
								data={filter}
								idx={idx + 1}
								key={idx}
								onChange={filter => {
									const newFilters = [...customFilters];
									newFilters[idx] = filter;
									onChange({ customFilters: newFilters });
								}}
							/>
						</>
					))}
			</Wrapper>
		</Section>
	);
};

CustomFiltersSection.propTypes = {
	animationIndex: PropTypes.number.isRequired,
	onChange: PropTypes.func.isRequired,
};

const CustomFilterItem = ({ data: filter, onChange, idx }) => {
	const { isActive, label, values } = filter;

	return (
		<ListRow>
			<ListToggleWrapper>
				<ToggleSwitch
					defaultChecked={isActive}
					onChange={() => {
						onChange({ ...filter, isActive: !isActive });
					}}
				/>
				<VerticalDivider />
			</ListToggleWrapper>
			<ListNameWrapper>
				<IndexText>{idx}</IndexText>
				<TextInput
					value={label}
					onChange={event => {
						onChange({ ...filter, label: event.target.value });
					}}
					required
				/>
			</ListNameWrapper>
			<ListOptionsWrapper>
				<OptionsText>
					{values
						.filter(option => option.label && option.label.length)
						.map(option => option.label)
						.join(', ')}
				</OptionsText>
			</ListOptionsWrapper>
		</ListRow>
	);
};
